module.exports = __webpack_public_path__ + "bc04a18e819e951db0d847d6d74ddae5.pdf";